import { toFormFieldText } from '../../../shared/utils/formValue';

export const EMPTY_ELECTRICITY_SUPPLIER_FORM = Object.freeze({
  registration_no: '',
  supplier_name_ja: '',
  is_active: true,
  entity_version: null,
});

export function toElectricitySupplierForm(supplier) {
  if (!supplier) return { ...EMPTY_ELECTRICITY_SUPPLIER_FORM };
  return {
    registration_no: toFormFieldText(supplier.registrationNo || supplier.registration_no),
    supplier_name_ja: toFormFieldText(supplier.nameJa || supplier.supplier_name_ja),
    is_active: supplier.isActive !== false,
    entity_version: Number(supplier.entity_version) || null,
  };
}

export function toElectricitySupplierPayload(values, { isEdit = false } = {}) {
  if (isEdit) {
    return {
      registration_no: values.registration_no.trim().toUpperCase(),
      supplier_name_ja: values.supplier_name_ja.trim(),
      is_active: values.is_active,
      entity_version: Number(values.entity_version),
    };
  }
  return {
    registration_no: values.registration_no.trim().toUpperCase(),
    supplier_name_ja: values.supplier_name_ja.trim(),
  };
}
